import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { AssetInventory } from '../models/entities/asset-inventory';
import { AssetInventoryRequest } from '../models/dto/asset-inventoryl-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';


@Injectable({
  providedIn: 'root'
})
export class AssetInventoryService {

  constructor(
    private networkService: LeanNetworkService,
    public userService : UserService) { }


//-----------------------------------------------------------------------------------------------------
 //-----------------------------------------------------------------------------------------------------

  assetInventoriesGet(closedIncluded: boolean) : Promise<AssetInventory[]> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);
    request.blnArg1 = closedIncluded;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetInventoriesGet', request).then(result => {
            return resolve(result.assetInventories);  
        }, error => {
            reject(error);
        });
    });
  }

  assetInventoryProcess(service : string, code? : string) : Promise<AssetInventory> {
    let request           : AssetInventoryRequest = new AssetInventoryRequest(this.userService.userInfo);
    request.service = service;
    request.code = code;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetInventoryProcess', request).then(result => {
          let assetInventory : AssetInventory = result.assetInventory;
          return resolve(assetInventory);
        }, error => {
            reject(error);
        });
    });
  }

  assetInventoryRegister(barCodes: string[]): Promise<boolean> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strings = barCodes;

    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetInventoryRegister', request).then(result => {
          return resolve(true);
        }, error => {
            reject(error);
        });
    });
  }

  getCurrentAssetInventory() : Promise<AssetInventory> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/currentAssetInventoryGet', request).then(result => {
          let currentAssetInventory = new AssetInventory();
          if (result.assetInventory){
            currentAssetInventory = result.assetInventory;
          }
          currentAssetInventory.totalBranch          = result.lngArg1;
          currentAssetInventory.alreadyInventoried  = result.lngArg2;
          return resolve(currentAssetInventory);
        }, error => {
            reject(error);
        });
    });
  }

  getAssetInventoryAssets(assetInventoryCode : string) : Promise<Asset[]> {
    let request           : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = assetInventoryCode;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('services/logistics/assetInventoryAssetsGet', request).then(result => {
          return resolve(result.assets);
        }, error => {
            reject(error);
        });
    });
  }


  
}


